import $api from "../../../axios"
import { IProjectDataSQP } from "../types/projectDataSQP.types"

interface IGetProjectDataSQP {
  projectId: string
  searchQuery?: string
  lastDate?: string
}

const projectsPath = "projects"
const getSQPData = async (
  params: IGetProjectDataSQP
): Promise<Record<string, IProjectDataSQP[]>> => {
  const response = await $api.get(projectsPath + "/project/SQP/", { params })
  return response.data
}

export default {
  getSQPData,
}
